export function TagList({ values }: { readonly values: readonly string[] }) {
  return (
    <div className="flex flex-wrap gap-1">
      {values.map((value) => (
        <span
          className="rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-ink-muted"
          key={value}
        >
          {value}
        </span>
      ))}
    </div>
  );
}
